import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Product, ProductVariant } from '../interfaces';

interface AddVariantsPopupProps {
    product: Product;
    onClose: () => void;
    onVariantSelected: (selectedVariant: ProductVariant) => void;
    onNext: () => void;
}


const AddVariantsPopup: React.FC<AddVariantsPopupProps> = ({ product, onClose, onVariantSelected, onNext }) => {
    const [displayErrorMessage, setDisplayErrorMessage] = useState(false);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    useEffect(() => {
        const handleResize = () => {
          setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

  
      useEffect(() => {
        const handleResize = () => {
            console.log("onresize: innerWidth: " + window.innerWidth + "innerHeight: " + innerHeight)
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.onresize = handleResize;

        return () => {
            window.onresize = null;
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const updateSize = () => {
            console.log("update size")
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
    
        window.addEventListener("resize", updateSize);
        window.addEventListener("focus", updateSize);
        document.addEventListener("visibilitychange", updateSize);
    
        return () => {
            window.removeEventListener("resize", updateSize);
            window.removeEventListener("focus", updateSize);
            document.removeEventListener("visibilitychange", updateSize);
        };
    }, []);

    const handleNext = () => {
        if (product.enforceVariants) {
            console.log("error");
            setDisplayErrorMessage(true);
    
            setTimeout(() => {
                setDisplayErrorMessage(false);
            }, 3000); 
        } else {
            onNext();
        }
    }

    const styles = StyleSheet.create({
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.40 : windowSize.width * 0.9,
            backgroundColor: '#fff',
            position: 'absolute',
            zIndex: 1000,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        },
        error: {
            backgroundColor: '#ffe2e0',
            borderColor: '#F04438',
            borderWidth: 1,
            borderStyle: 'solid',
            shadowColor: 'rgba(16, 24, 40, 0.08)',
            shadowOffset: { width: 0, height: 12 },
            shadowOpacity: 0.16,
            shadowRadius: 16,
            elevation: 5,
            position: 'absolute',
            top: 20,
            
        }
    });

    return (
        <div style={styles.popup} className='ds-pop ds-pop--center'>
            <div className='d-flex px-3 pt-3 justify-content-end'>
                <button className='text-btn p-0 m-0 d-flex justify-content-center' onClick={onClose}>
                    <svg width="10" height="10" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1L13 13" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
            </div>
            <div className='px-4 pb-3'>
                <h5>Add Variants</h5>
                {
                    product.variants.map(variant =>
                        <div className='border-box p-2 mt-2 d-flex justify-content-between'>
                            <label style={{fontWeight: '500', fontSize: '14px'}} className='d-flex align-items-center'>{variant.name}</label>
                            <button className='blue-filled-btn' onClick={() => onVariantSelected(variant)}>Select</button>
                        </div>
                    )
                }
            </div>
            <div className='p-2 d-flex justify-content-end' style={{ backgroundColor: '#F3F4F6' }}>
                <button className='white-filled-btn ' onClick={handleNext}>Next</button>
            </div>

            {
                displayErrorMessage &&
                <div style={{ ...styles.error, left: '3%', width: '94%' }} className='p-2'>
                    <div className='d-flex'>
                        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.3">
                                <path d="M6 19C6 11.8203 11.8203 6 19 6C26.1797 6 32 11.8203 32 19C32 26.1797 26.1797 32 19 32C11.8203 32 6 26.1797 6 19Z" stroke="#F04438" stroke-width="2" />
                            </g>
                            <g opacity="0.1">
                                <path d="M1 19C1 9.05888 9.05888 1 19 1C28.9411 1 37 9.05888 37 19C37 28.9411 28.9411 37 19 37C9.05888 37 1 28.9411 1 19Z" stroke="#F04438" stroke-width="2" />
                            </g>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0002 9.83398C13.9376 9.83398 9.8335 13.938 9.8335 19.0007C9.8335 24.0633 13.9376 28.1673 19.0002 28.1673C24.0628 28.1673 28.1668 24.0633 28.1668 19.0007C28.1668 13.938 24.0628 9.83398 19.0002 9.83398ZM22.0894 15.9114C22.4149 16.2368 22.4149 16.7645 22.0894 17.0899L20.1787 19.0007L22.0894 20.9114C22.4149 21.2368 22.4149 21.7645 22.0894 22.0899C21.764 22.4153 21.2363 22.4153 20.9109 22.0899L19.0002 20.1792L17.0894 22.0899C16.764 22.4153 16.2363 22.4153 15.9109 22.0899C15.5855 21.7645 15.5855 21.2368 15.9109 20.9114L17.8217 19.0007L15.9109 17.0899C15.5855 16.7645 15.5855 16.2368 15.9109 15.9114C16.2363 15.586 16.764 15.586 17.0894 15.9114L19.0002 17.8221L20.9109 15.9114C21.2363 15.586 21.764 15.586 22.0894 15.9114Z" fill="#F04438" />
                        </svg>
                        <div className='d-flex px-2 flex-column'>
                            <label style={{ color: '#B42318' }}>Invalid selection</label>
                            <span style={{ color: '#344054', fontSize: '14px' }}>This product has enforced variants. <br />
                                Please select at least one option.</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};




export default AddVariantsPopup;

